module.exports = __webpack_public_path__ + "media/images/service/b_rj-c5faf89da319af8ac2f6a1a80a8ea5c0.png";